import React, { useContext, useEffect, useState } from 'react';
import { Marker, useMap } from 'react-leaflet';

import { ProfileContext } from '../../services/profile/profile.context';
import { SaveChanges } from '../../components/utility/save-changes';
import { UserLocationMap } from './user-location-map';
import { SuccessMsg } from '../../components/utility/success-msg';
import { Box } from '@material-ui/core';

function LocationMarker() {
  const map = useMap();
  const [position, setPosition] = useState(null);
  useEffect(() => {
    map.locate();
    map.locate().on('locationfound', function (e) {
      setPosition(e.latlng);
      map.flyTo(e.latlng, map.getZoom());
    });
    return position === null ? null : <Marker position={position}></Marker>;
  }, [position, map]);
  return null;
}

export const UserLocation = () => {
  const { saveUserLocation } = useContext(ProfileContext);
  const [show, setShow] = useState(false);

  return (
    <div>
      <Box boxShadow={3} height={300}>
        <UserLocationMap />
      </Box>
      <SaveChanges
        route={'/meetings'}
        click={saveUserLocation}
        setShow={setShow}
        id='location'
      />

      <SuccessMsg show={show} setShow={setShow} />
    </div>
  );
};
